import moment from 'moment';
import { computed, makeObservable, observable } from 'mobx';
import { IBasePaginationRequest } from '../../dto/base.dto';
import { formatNumber } from 'src/helpers/common.utils';

export interface ISummary {
	proposalLoanAmount: string;
	loanRate: string;
	interestPerYear: string;
	loadPeriod: string;
	LTV: string;
	interestPaymentPeriod: string;
	borrowAmountCurrency: string;
}

export interface IMDApplicationRequest extends IBasePaginationRequest {
	status?: number[];
}

export interface IMortgageDealItem {
	id: string;
	mortgageDealNumber: string;
	status: number;
	country: string;
	district: string;
	addressLine: string;
	zipCode: string;
	paymentProgress?: number;
	summary?: ISummary;
	isCorporateRequest: boolean;
	remark?: string;
	isReadyToSelectProposal: boolean;
}

export class MortgageDeal {
	public mortgageNumber!: string;
	public coverPhotoId!: string;
	public country!: string;
	public district!: string;
	public isMortgageGreen!: boolean;
	public addressLine!: string;
	public loanPeriod!: number;
	public loanRateFrom!: number;
	public loanRateTo!: number;
	public mortgageApplicationId!: string;
	public propertyApprovedAt!: string;
	public securityValue!: number;
	public securityValueCurrency?: string;
	public street!: string;
	public isFavorite!: boolean;
	public annualReturn!: number;
	public epcRating?: string;
	public belsRating?: string;
	public loanAmount!: number;
	public loanAmountCurrency!: string;

	// FE computed value
	public currentTime?: number;

	public get leftToInvest() {
		const endTime = moment(this.propertyApprovedAt).add(2, 'w');
		const duration = moment.duration(endTime.diff(moment(this.currentTime)));
		return endTime.isAfter(moment(this.currentTime)) ? `${duration.days()}D : ${duration.hours()}H : ${duration.minutes()}M` : '0D:0H:0M'
	}

	public get isAvailable() {
		return moment(this.propertyApprovedAt).add(2, 'w').isAfter(moment(this.currentTime));
	}

	public get formattedSecurityValue() {
		return `${this.securityValue} ${this.securityValueCurrency || ''}`;
	}

	public get formattedLoanPeriod() {
		return `${this.loanPeriod} months`;
	}

	public get loanRate() {
		return `${this.loanRateFrom}% - ${this.loanRateTo}%`;
	}

	public get formattedLoanAmount() {
		return formatNumber(this.loanAmountCurrency, this.loanAmount);
	}

	public get rating() {
		return this.epcRating || this.belsRating;
	}

	constructor() {
		makeObservable(this, {
			currentTime: observable,
			isFavorite: observable,
			isAvailable: computed,
			leftToInvest: computed,
		})
	}
}
